export default __webpack_public_path__ + "static/media/VN.f99a657d.svg";